module.exports = __webpack_public_path__ + "static/media/PedalMulambo.17d71f5c.jpeg";